import ApiClient from './apiClient'
import {
  ManagerInfo,
  PostNewMembersParams,
  PatchPasswordParams,
} from '../types/tutorial'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTutorial = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/tutorial',
  (result: ManagerInfo) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postNewMembers = async (params: PostNewMembersParams): Promise<any> => ApiClient.post(
  '/api/v1/renderer/tutorial',
  (result: Record<string, unknown>) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchPassword = async (params: PatchPasswordParams): Promise<any> => ApiClient.patch(
  '/api/v1/renderer/setting/member/password',
  () => {
    // do nothing
  },
  params,
)
